// extracted by mini-css-extract-plugin
export default {"container":"Structure_container__5B-cc","imagebox_container":"Structure_imagebox_container__NJL3+","horizontal_scroll_view":"Structure_horizontal_scroll_view__Nee3x"};